<div class="store-pomo-container">
  <div *ngFor="let promos of promoTileData; let i = index ">
    <div class="promo-content-section" [ngClass]="setIntelDisplayOneFont ? 'intelOne-display':''"
      [ngStyle]="setBackground(promos.id, promos.configurations)" (click)="routeToTileDetailsPage('promos', i)">
      <span *ngIf="!promos.configurations.contentGroupPages[0].linkedAssetFileType.includes('image')"
        [innerHTML]="promos.configurations.publishedName"></span>
      <div class="promo-title-container" [class.rtl-lang-container]="isRTL"> 
        <span [innerHTML]="promos.configurations.publishedName"></span>
      </div>
    </div>
  </div>
</div>
